module.exports = "<block-ui [template]=\"blockTemplate\">\r\n    <router-outlet></router-outlet>\r\n</block-ui>";